import { Loading, useRemote } from './Controls';
import { MediaThumbnail } from './HeroMediaEditor';
export default function EffectiveRecordMedia({ domain, id, revision }) {
  const remote = useRemote(id ? `/admin/effective-media/${domain}/${id}` : null, revision);
  if (!id) return null;
  return <section className="aw-panel"><h2>Published page media</h2><Loading state={remote}>
    {remote.data?.status === 'ready' ? <MediaThumbnail media={remote.data} label="Effective published image" /> :
      <p className="aw-muted">{remote.data?.reason || (remote.data?.status === 'unpublished' ? 'This record is not published.' : 'This page uses no hero photograph.')}</p>}
  </Loading></section>;
}
